import { AI_WORKSHOP, CONFERENCE } from "@/data/content";
import Reveal from "@/components/Reveal";
import { Check, ArrowRight, Cpu } from "lucide-react";

export default function AIWorkshop() {
  return (
    <section id="ai-workshop" className="relative py-24 sm:py-32 px-5 sm:px-8 lg:px-12 bg-ink text-white overflow-hidden">
      <div className="absolute top-0 right-0 w-[40rem] h-[40rem] bg-crimson/20 blur-[140px] rounded-full pointer-events-none" />
      <div className="absolute inset-0 noise-overlay opacity-[0.04] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto">
        <Reveal>
          <div className="flex items-center gap-3 mb-6">
            <Cpu size={18} className="text-crimson" />
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-crimson font-semibold">{AI_WORKSHOP.eyebrow}</p>
          </div>
          <h2 className="font-heading text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tighter leading-[0.92] max-w-4xl">
            {AI_WORKSHOP.heading}
          </h2>
          <p className="mt-6 text-xl sm:text-2xl text-white/80 font-medium max-w-3xl">{AI_WORKSHOP.subhead}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <blockquote className="mt-12 border-l-2 border-crimson pl-6 sm:pl-8 max-w-3xl">
            <p className="font-heading text-2xl sm:text-3xl font-medium leading-snug text-white">
              “{AI_WORKSHOP.pullQuote}”
            </p>
          </blockquote>
        </Reveal>

        <div className="mt-16 grid lg:grid-cols-2 gap-12 lg:gap-20">
          <div>
            <Reveal>
              <p className="text-white/70 text-lg leading-relaxed">{AI_WORKSHOP.intro}</p>
            </Reveal>
            <div className="mt-10 space-y-px border-t border-white/15">
              {AI_WORKSHOP.arc.map((a, i) => (
                <Reveal key={a.title} delay={i * 0.08}>
                  <div className="group flex items-start gap-6 py-6 border-b border-white/15 hover:pl-2 transition-all">
                    <span className="font-mono text-crimson text-sm font-semibold pt-1">{a.step}</span>
                    <div>
                      <h3 className="font-heading text-2xl font-semibold tracking-tight">{a.title}</h3>
                      <p className="text-white/60 mt-1">{a.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:pt-2">
            <Reveal delay={0.12}>
              <div className="border border-white/15 bg-white/[0.03] p-8 sm:p-10">
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50 mb-6">You walk out with</p>
                <ul className="space-y-4">
                  {AI_WORKSHOP.checklist.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-white/90">
                      <Check size={18} className="text-crimson shrink-0 mt-1" />
                      <span className="text-[15px] leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-8 pt-6 border-t border-white/15">
                  <p className="font-mono text-xs text-white/55 leading-relaxed">{AI_WORKSHOP.details}</p>
                  <button
                    onClick={() => document.querySelector("#register")?.scrollIntoView({ behavior: "smooth" })}
                    data-testid="ai-workshop-cta"
                    className="mt-6 w-full bg-crimson text-white font-semibold px-7 py-4 flex items-center justify-center gap-2 hover:bg-white hover:text-ink transition-colors group"
                  >
                    Reserve your seat <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
